import { render, staticRenderFns } from "./GiftsDialog.vue?vue&type=template&id=2adda4c4&scoped=true"
import script from "./GiftsDialog.vue?vue&type=script&lang=js"
export * from "./GiftsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adda4c4",
  null
  
)

export default component.exports